module.exports = __webpack_public_path__ + "img/tips12.2faa1ef7.png";